import { Component, OnInit, AfterViewInit } from '@angular/core';

declare const lucide: any;

@Component({
  selector: 'app-analytics',
  templateUrl: './analytics.component.html',
  styles: [`
    /* Essential Styles */
    .analytics-banner-section {
      background: linear-gradient(135deg, #1c3e8a 0%, #2c5aa0 100%);
      padding: 120px 0 60px;
      color: #fff;
      position: relative;
      overflow: hidden;
    }
    
    .analytics-banner-section:before {
      content: '';
      position: absolute;
      inset: 0;
      background: radial-gradient(circle at 80% 20%, rgba(255,255,255,0.12), transparent 40%),
                  radial-gradient(circle at 20% 80%, rgba(255,255,255,0.08), transparent 40%);
    }
    
    .banner-bg-pattern {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.05)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
      opacity: 0.3;
    }
    
    .analytics-banner-heading {
      font-size: 3rem;
      line-height: 1.15;
    }
    
    .analytics-banner-subheading {
      font-size: 1.3rem;
      opacity: 0.92;
      color: #e3f2fd;
    }
    
    .analytics-banner-desc {
      font-size: 1.05rem;
      line-height: 1.8;
      opacity: 0.95;
    }
    
    .banner-visual {
      border-radius: 50px;
      max-height: 340px;
      box-shadow: 0 20px 40px rgba(0,0,0,0.2);
    }
    
    .container {
      max-width: 1200px;
      margin: 0 auto;
      padding: 0 15px;
    }
    
    .row {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }
    
    .col-lg-7 {
      flex: 0 0 58.333333%;
      max-width: 58.333333%;
      padding: 0 15px;
    }
    
    .col-lg-5 {
      flex: 0 0 41.666667%;
      max-width: 41.666667%;
      padding: 0 15px;
    }
    
    .col-lg-12 {
      flex: 0 0 100%;
      max-width: 100%;
      padding: 0 15px;
    }
    
    .col-lg-6 {
      flex: 0 0 50%;
      max-width: 50%;
      padding: 0 15px;
    }
    
    .col-lg-4 {
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
      padding: 0 15px;
    }
    
    .col-lg-3 {
      flex: 0 0 25%;
      max-width: 25%;
      padding: 0 15px;
    }
    
    .col-lg-8 {
      flex: 0 0 66.666667%;
      max-width: 66.666667%;
      padding: 0 15px;
    }
    
    .col-md-6 {
      flex: 0 0 50%;
      max-width: 50%;
      padding: 0 15px;
    }
    
    .col-md-4 {
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
      padding: 0 15px;
    }
    
    .col-md-3 {
      flex: 0 0 25%;
      max-width: 25%;
      padding: 0 15px;
    }
    
    .mb-4 { margin-bottom: 1.5rem; }
    .mb-5 { margin-bottom: 3rem; }
    .mb-lg-0 { margin-bottom: 0; }
    .mt-3 { margin-top: 1rem; }
    .mt-4 { margin-top: 1.5rem; }
    .d-flex { display: flex; }
    .flex-wrap { flex-wrap: wrap; }
    .gap-3 { gap: 1rem; }
    .align-items-center { align-items: center; }
    .text-center { text-align: center; }
    .text-left { text-align: left; }
    .text-white { color: white !important; }
    .justify-content-center { justify-content: center; }
    .img-fluid { max-width: 100%; height: auto; }
    .btn { display: inline-block; padding: 0.375rem 0.75rem; margin-bottom: 0; font-size: 1rem; font-weight: 600; line-height: 1.5; text-align: center; text-decoration: none; vertical-align: middle; cursor: pointer; border: 1px solid transparent; border-radius: 0.25rem; }
    .btn-lg { padding: 0.5rem 1rem; font-size: 1rem; border-radius: 0.3rem; }
    .px-4 { padding-left: 1.5rem; padding-right: 1.5rem; }
    .py-3 { padding-top: 1rem; padding-bottom: 1rem; }
    .rounded-pill { border-radius: 50rem; }
    .common-blue-bg { background-color: #1c3e8a; }
    .font-segoe-bold { font-weight: 700; }
    .section-heading { font-size: 2.5rem; font-weight: 700; color: #1c3e8a; margin-bottom: 1rem; }
    .section-subheading { font-size: 1.25rem; color: #666; margin-bottom: 2rem; }
    .section-padding-top { padding-top: 80px; }
    .section-padding-bottom { padding-bottom: 80px; }
    
    .analytics-grid {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }
    
    .analytics-grid > [class*='col-'] {
      display: flex;
      padding: 0 15px;
    }
    
    /* Analytics Cards */
    .analytics-card {
      background: #fff;
      border-radius: 20px;
      padding: 32px 28px;
      box-shadow: 0 12px 32px rgba(0,0,0,0.08);
      border: 1px solid rgba(28,62,138,0.1);
      transition: all .4s cubic-bezier(.25,.8,.25,1);
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      margin-bottom: 1.5rem;
    }
    
    .analytics-card:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 5px;
      border-radius: 20px 20px 0 0;
    }
    
    .analytics-card.analytics-blue:before {
      background: linear-gradient(90deg, #1c3e8a, #2c5aa0, #4ecdc4);
    }
    
    .analytics-card.analytics-red:before {
      background: linear-gradient(90deg, #ff6b6b, #ff8e53, #ffa500);
    }
    
    .analytics-card:hover {
      transform: translateY(-8px) scale(1.02);
      box-shadow: 0 24px 48px rgba(28,62,138,0.15);
      border-color: rgba(28,62,138,0.2);
    }
    
    .analytics-icon {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 20px;
      box-shadow: 0 10px 24px rgba(28,62,138,0.3);
      position: relative;
      z-index: 2;
    }
    
    .analytics-card.analytics-blue .analytics-icon {
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
    }
    
    .analytics-card.analytics-red .analytics-icon {
      background: linear-gradient(135deg, #ff6b6b, #ff8e53);
    }
    
    .analytics-icon i {
      width: 28px;
      height: 28px;
      stroke: white;
      stroke-width: 2;
    }
    
    .analytics-icon svg {
      width: 28px;
      height: 28px;
      stroke: white;
      stroke-width: 2;
    }
    
    .analytics-title {
      color: #1c3e8a;
      font-weight: 700;
      font-size: 1.3rem;
      margin-bottom: 8px;
      line-height: 1.3;
    }
    
    .analytics-subtitle {
      color: #666;
      font-size: 1rem;
      font-weight: 600;
      margin-bottom: 12px;
      font-style: italic;
    }
    
    .analytics-description {
      color: #666;
      line-height: 1.7;
      margin-bottom: 20px;
      flex: 1;
    }
    
    .analytics-features {
      list-style: none;
      padding: 0;
      margin: 0;
    }
    
    .analytics-features li {
      color: #555;
      font-size: 0.9rem;
      line-height: 1.6;
      margin-bottom: 8px;
      padding-left: 20px;
      position: relative;
    }
    
    .analytics-features li:before {
      content: '✓';
      position: absolute;
      left: 0;
      color: #1c3e8a;
      font-weight: bold;
    }
    
    .analytics-cta {
      margin-top: 20px;
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
    }
    
    .analytics-cta-btn {
      flex: 1;
      min-width: 120px;
      text-align: center;
    }
    
    .btn-outline-primary {
      background: transparent;
      border: 2px solid #1c3e8a;
      color: #1c3e8a;
      padding: 0.5rem 1rem;
      border-radius: 0.3rem;
      font-size: 1rem;
      font-weight: 600;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.3s ease;
    }
    
    .btn-outline-primary:hover {
      background: #1c3e8a;
      color: white;
      text-decoration: none;
    }
    
    .btn-primary {
      background: #1c3e8a;
      border: 2px solid #1c3e8a;
      color: white;
      padding: 0.5rem 1rem;
      border-radius: 0.3rem;
      font-size: 1rem;
      font-weight: 600;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.3s ease;
    }
    
    .btn-primary:hover {
      background: #2c5aa0;
      border-color: #2c5aa0;
      color: white;
      text-decoration: none;
    }
    
    /* Benefits Cards */
    .benefit-card {
      background: #fff;
      border-radius: 16px;
      padding: 28px 22px;
      box-shadow: 0 8px 24px rgba(0,0,0,0.08);
      border: 1px solid #e9ecef;
      transition: transform .35s ease, box-shadow .35s ease;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      text-align: center;
      margin-bottom: 1.5rem;
    }
    
    .benefit-card:before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #1c3e8a, #2c5aa0);
    }
    
    .benefit-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 18px 34px rgba(0,0,0,0.12);
    }
    
    .benefit-icon {
      width: 60px;
      height: 60px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      margin: 0 auto 18px;
      box-shadow: 0 8px 18px rgba(28,62,138,0.3);
    }
    
    .benefit-icon i {
      width: 24px;
      height: 24px;
      stroke: white;
      stroke-width: 2;
    }
    
    .benefit-icon svg {
      width: 24px;
      height: 24px;
      stroke: white;
      stroke-width: 2;
    }
    
    .benefit-title {
      color: #1c3e8a;
      font-weight: 600;
      font-size: 1.2rem;
      margin-bottom: 10px;
    }
    
    .benefit-description {
      color: #666;
      line-height: 1.65;
    }
    
    .benefits-grid {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }
    
    .benefits-grid > [class*='col-'] {
      display: flex;
      padding: 0 15px;
    }
    
    /* Benefits Section Redesigned Styles */
    .benefits-bg-pattern {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="analytics-pattern" width="30" height="30" patternUnits="userSpaceOnUse"><circle cx="15" cy="15" r="2" fill="rgba(28,62,138,0.05)"/><path d="M0,15 L30,15 M15,0 L15,30" stroke="rgba(28,62,138,0.03)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23analytics-pattern)"/></svg>');
      opacity: 0.6;
    }
    
    .offset-lg-1 {
      margin-left: 8.333333%;
    }
    
    .benefits-intro-content {
      max-width: 900px;
      margin: 0 auto;
    }
    
    .benefits-intro-text {
      color: #666;
      font-size: 1.2rem;
      line-height: 1.8;
      margin: 0;
    }
    
    .benefits-visual {
      position: relative;
      z-index: 2;
    }
    
    .benefits-image-container {
      position: relative;
      border-radius: 20px;
      overflow: hidden;
      box-shadow: 0 20px 50px rgba(28, 62, 138, 0.15);
      transition: all 0.3s ease;
    }
    
    .benefits-image-container:hover {
      transform: translateY(-5px);
      box-shadow: 0 25px 60px rgba(28, 62, 138, 0.2);
    }
    
    .benefits-main-image {
      width: 100%;
      height: auto;
      display: block;
      border-radius: 20px;
      transition: transform 0.3s ease;
    }
    
    .benefits-image-container:hover .benefits-main-image {
      transform: scale(1.05);
    }
    
    .image-overlay-badge {
      position: absolute;
      top: 20px;
      right: 20px;
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(10px);
      padding: 12px 20px;
      border-radius: 25px;
      display: flex;
      align-items: center;
      gap: 10px;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      border: 1px solid rgba(255, 255, 255, 0.3);
      z-index: 2;
    }
    
    .badge-icon {
      width: 20px;
      height: 20px;
      color: #1c3e8a;
    }
    
    .image-overlay-badge span {
      color: #1c3e8a;
      font-weight: 600;
      font-size: 0.9rem;
      white-space: nowrap;
    }
    
    .benefits-content {
      padding: 20px 0;
    }
    
    .feature-category-badge {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      color: white;
      padding: 8px 16px;
      border-radius: 20px;
      font-size: 0.85rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 20px;
      box-shadow: 0 4px 15px rgba(28, 62, 138, 0.3);
    }
    
    .category-icon {
      width: 16px;
      height: 16px;
    }
    
    .benefits-content-title {
      color: #1c3e8a;
      font-size: 2rem;
      font-weight: 700;
      margin-bottom: 20px;
      line-height: 1.3;
    }
    
    .benefits-content-description {
      color: #666;
      font-size: 1.1rem;
      line-height: 1.8;
      margin-bottom: 25px;
    }
    
    .benefits-features-list {
      list-style: none;
      padding: 0;
      margin: 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
    }
    
    .benefits-features-list li {
      display: flex;
      align-items: center;
      color: #333;
      font-size: 1rem;
      line-height: 1.6;
    }
    
    .list-check-icon {
      width: 20px;
      height: 20px;
      color: #28a745;
      margin-right: 12px;
      flex-shrink: 0;
    }
    
    .benefits-stats-panel {
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      border-radius: 20px;
      padding: 40px 30px;
      box-shadow: 0 20px 50px rgba(28, 62, 138, 0.2);
      position: relative;
      overflow: hidden;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 25px;
    }
    
    .benefits-stats-panel::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="stats-pattern" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23stats-pattern)"/></svg>');
      opacity: 0.3;
    }
    
    .benefits-stat-item {
      display: flex;
      align-items: center;
      padding: 25px;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 15px;
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      transition: all 0.3s ease;
      position: relative;
      z-index: 2;
    }
    
    .benefits-stat-item:hover {
      transform: translateX(5px);
      background: rgba(255, 255, 255, 0.15);
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
    }
    
    .stat-icon-wrapper {
      width: 60px;
      height: 60px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 15px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      flex-shrink: 0;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
    }
    
    .stat-icon-wrapper i {
      width: 28px;
      height: 28px;
    }
    
    .stat-content-wrapper {
      flex: 1;
    }
    
    .stat-content-wrapper .stat-number {
      font-size: 2.2rem;
      font-weight: 700;
      color: white;
      margin-bottom: 5px;
      line-height: 1;
    }
    
    .stat-content-wrapper .stat-label {
      font-size: 0.95rem;
      color: rgba(255, 255, 255, 0.9);
      text-transform: uppercase;
      letter-spacing: 0.5px;
      font-weight: 600;
    }
    
    .benefits-section-title {
      color: #1c3e8a;
      font-size: 1.8rem;
      font-weight: 700;
      margin: 0 0 15px 0;
      padding-bottom: 15px;
      border-bottom: 2px solid #e9ecef;
    }
    
    /* Convergence Value Section */
    .convergence-value-header {
      text-align: center;
      margin-bottom: 40px;
    }
    
    .convergence-value-subtitle {
      color: #666;
      font-size: 1.1rem;
      line-height: 1.7;
      max-width: 800px;
      margin: 0 auto;
      margin-top: 15px;
    }
    
    .convergence-value-grid {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }
    
    .convergence-value-grid > [class*='col-'] {
      display: flex;
      padding: 0 15px;
    }
    
    .convergence-value-card {
      background: #fff;
      border-radius: 20px;
      padding: 35px 30px;
      box-shadow: 0 10px 35px rgba(28, 62, 138, 0.08);
      border: 1px solid #e9ecef;
      transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
    }
    
    .convergence-value-card::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 5px;
      background: linear-gradient(90deg, #1c3e8a, #2c5aa0, #4ecdc4);
      border-radius: 20px 20px 0 0;
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    .convergence-value-card:hover {
      transform: translateY(-10px);
      box-shadow: 0 20px 50px rgba(28, 62, 138, 0.15);
      border-color: rgba(28, 62, 138, 0.2);
    }
    
    .convergence-value-card:hover::before {
      opacity: 1;
    }
    
    .convergence-value-icon {
      width: 75px;
      height: 75px;
      border-radius: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      margin-bottom: 20px;
      box-shadow: 0 12px 30px rgba(28, 62, 138, 0.3);
      transition: all 0.3s ease;
      position: relative;
      z-index: 2;
    }
    
    .convergence-value-card:hover .convergence-value-icon {
      transform: scale(1.1) rotate(5deg);
      box-shadow: 0 15px 40px rgba(28, 62, 138, 0.4);
    }
    
    .convergence-value-icon i {
      width: 32px;
      height: 32px;
    }
    
    .convergence-value-badge {
      display: inline-block;
      background: linear-gradient(135deg, #e3f2fd, #bbdefb);
      color: #1c3e8a;
      padding: 6px 14px;
      border-radius: 15px;
      font-size: 0.75rem;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 15px;
      align-self: flex-start;
      box-shadow: 0 4px 12px rgba(28, 62, 138, 0.15);
    }
    
    .convergence-value-title {
      color: #1c3e8a;
      font-weight: 700;
      font-size: 1.4rem;
      margin-bottom: 12px;
      line-height: 1.3;
    }
    
    .convergence-value-description {
      color: #666;
      line-height: 1.7;
      font-size: 1rem;
      margin-bottom: 20px;
      flex: 1;
    }
    
    .convergence-value-examples {
      margin-bottom: 25px;
      padding-top: 20px;
      border-top: 1px solid #f0f4f8;
    }
    
    .example-item {
      display: flex;
      align-items: flex-start;
      margin-bottom: 12px;
      color: #333;
      font-size: 0.9rem;
      line-height: 1.6;
    }
    
    .example-item:last-child {
      margin-bottom: 0;
    }
    
    .example-icon {
      width: 18px;
      height: 18px;
      color: #28a745;
      margin-right: 10px;
      flex-shrink: 0;
      margin-top: 2px;
    }
    
    .example-text {
      flex: 1;
      color: #555;
    }
    
    .convergence-value-impact {
      margin-top: auto;
      padding-top: 20px;
      border-top: 2px solid #f0f4f8;
      text-align: center;
    }
    
    .impact-metric {
      font-size: 2rem;
      font-weight: 700;
      color: #1c3e8a;
      margin-bottom: 5px;
      line-height: 1;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
    }
    
    .impact-label {
      font-size: 0.85rem;
      color: #666;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      font-weight: 600;
    }
    
    .benefit-card-enhanced {
      background: #fff;
      border-radius: 18px;
      padding: 30px 25px;
      box-shadow: 0 8px 30px rgba(28, 62, 138, 0.08);
      border: 1px solid #e9ecef;
      transition: all 0.3s ease;
      height: 100%;
      display: flex;
      flex-direction: column;
      position: relative;
      overflow: hidden;
      text-align: center;
    }
    
    .benefit-card-enhanced::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 4px;
      background: linear-gradient(90deg, #1c3e8a, #2c5aa0);
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    
    .benefit-card-enhanced:hover {
      transform: translateY(-8px);
      box-shadow: 0 15px 40px rgba(28, 62, 138, 0.15);
      border-color: rgba(28, 62, 138, 0.2);
    }
    
    .benefit-card-enhanced:hover::before {
      opacity: 1;
    }
    
    .benefit-icon-enhanced {
      width: 70px;
      height: 70px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      margin: 0 auto 20px;
      box-shadow: 0 10px 30px rgba(28, 62, 138, 0.3);
      transition: all 0.3s ease;
    }
    
    .benefit-card-enhanced:hover .benefit-icon-enhanced {
      transform: scale(1.1);
      box-shadow: 0 15px 40px rgba(28, 62, 138, 0.4);
    }
    
    .benefit-icon-enhanced i {
      width: 28px;
      height: 28px;
    }
    
    .benefit-title-enhanced {
      color: #1c3e8a;
      font-weight: 700;
      font-size: 1.3rem;
      margin-bottom: 12px;
      line-height: 1.3;
    }
    
    .benefit-description-enhanced {
      color: #666;
      line-height: 1.7;
      flex: 1;
      margin-bottom: 15px;
    }
    
    .benefit-arrow {
      margin-top: auto;
      opacity: 0;
      transition: all 0.3s ease;
      transform: translateX(-10px);
    }
    
    .benefit-card-enhanced:hover .benefit-arrow {
      opacity: 1;
      transform: translateX(0);
    }
    
    .benefit-arrow i {
      width: 24px;
      height: 24px;
    }
    
    /* Convergence Flow */
    .convergence-flow {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      gap: 20px;
      padding: 40px;
      background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
      border-radius: 25px;
      box-shadow: 0 10px 40px rgba(28, 62, 138, 0.1);
      border: 1px solid #e9ecef;
      position: relative;
      overflow: hidden;
    }
    
    .convergence-flow::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="convergence-pattern" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="rgba(28,62,138,0.05)"/></pattern></defs><rect width="100" height="100" fill="url(%23convergence-pattern)"/></svg>');
      opacity: 0.4;
    }
    
    .convergence-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: #fff;
      padding: 25px 30px;
      border-radius: 18px;
      box-shadow: 0 8px 25px rgba(28, 62, 138, 0.1);
      border: 2px solid #e9ecef;
      transition: all 0.3s ease;
      position: relative;
      z-index: 2;
      min-width: 180px;
    }
    
    .convergence-item:hover {
      transform: translateY(-5px);
      box-shadow: 0 15px 35px rgba(28, 62, 138, 0.15);
      border-color: rgba(28, 62, 138, 0.3);
    }
    
    .convergence-icon {
      width: 60px;
      height: 60px;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;
      box-shadow: 0 8px 25px rgba(28, 62, 138, 0.3);
    }
    
    .convergence-icon i {
      width: 28px;
      height: 28px;
    }
    
    .convergence-content {
      text-align: center;
    }
    
    .convergence-title {
      color: #1c3e8a;
      font-size: 1.1rem;
      font-weight: 700;
      margin: 0 0 5px 0;
      line-height: 1.3;
    }
    
    .convergence-description {
      color: #666;
      font-size: 0.9rem;
      margin: 0;
      line-height: 1.5;
    }
    
    .convergence-connector {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 2;
    }
    
    .convergence-connector i {
      width: 32px;
      height: 32px;
      color: #1c3e8a;
    }
    
    .convergence-result {
      display: flex;
      flex-direction: column;
      align-items: center;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      padding: 30px 35px;
      border-radius: 18px;
      box-shadow: 0 12px 35px rgba(28, 62, 138, 0.3);
      transition: all 0.3s ease;
      position: relative;
      z-index: 2;
      min-width: 200px;
    }
    
    .convergence-result:hover {
      transform: translateY(-5px) scale(1.05);
      box-shadow: 0 18px 45px rgba(28, 62, 138, 0.4);
    }
    
    .convergence-result-icon {
      width: 70px;
      height: 70px;
      background: rgba(255, 255, 255, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 15px;
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
    }
    
    .convergence-result-icon i {
      width: 32px;
      height: 32px;
    }
    
    .convergence-result-content {
      text-align: center;
    }
    
    .convergence-result-title {
      color: white;
      font-size: 1.2rem;
      font-weight: 700;
      margin: 0 0 5px 0;
      line-height: 1.3;
    }
    
    .convergence-result-description {
      color: rgba(255, 255, 255, 0.9);
      font-size: 0.95rem;
      margin: 0;
      line-height: 1.5;
    }
    
    /* Results Cards */
    .result-card {
      background: linear-gradient(135deg, #1c3e8a 0%, #2c5aa0 100%);
      color: #ffffff;
      border-radius: 15px;
      padding: 40px 30px;
      text-align: center;
      position: relative;
      overflow: hidden;
      transition: transform .35s ease, box-shadow .35s ease;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 1.5rem;
    }
    
    .result-card::before {
      content: '';
      position: absolute;
      top: -50%;
      right: -50%;
      width: 100%;
      height: 100%;
      background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 50%);
      animation: rotate 20s linear infinite;
    }
    
    .result-card:hover {
      transform: translateY(-8px);
      box-shadow: 0 20px 40px rgba(28, 62, 138, 0.3);
    }
    
    .result-number {
      font-size: 3rem;
      font-weight: 700;
      margin-bottom: 15px;
      position: relative;
      z-index: 2;
    }
    
    .result-title {
      font-size: 1.2rem;
      font-weight: 600;
      margin-bottom: 10px;
      position: relative;
      z-index: 2;
    }
    
    .result-description {
      color: rgba(255, 255, 255, 0.9);
      line-height: 1.65;
      font-size: 1rem;
      position: relative;
      z-index: 2;
    }
    
    @keyframes rotate {
      from { transform: rotate(0deg); }
      to { transform: rotate(360deg); }
    }
    
    .results-grid {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -15px;
    }
    
    .results-grid > [class*='col-'] {
      display: flex;
      padding: 0 15px;
    }
    
    /* Section Backgrounds */
    .analytics-types-section {
      background: linear-gradient(180deg, #f8f9fa 0%, #ffffff 100%);
      position: relative;
    }
    
    .section-bg-pattern {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><defs><pattern id="dots" width="20" height="20" patternUnits="userSpaceOnUse"><circle cx="10" cy="10" r="1" fill="rgba(28,62,138,0.08)"/></pattern></defs><rect width="60" height="60" fill="url(%23dots)"/></svg>');
      opacity: 0.4;
    }
    
    .benefits-section {
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
      position: relative;
      overflow: hidden;
    }
    
    .benefits-section:before {
      content: '';
      position: absolute;
      top: -120px;
      left: -120px;
      width: 340px;
      height: 340px;
      background: radial-gradient(closest-side, rgba(28,62,138,0.12), rgba(28,62,138,0));
      filter: blur(4px);
    }
    
    .benefits-section:after {
      content: '';
      position: absolute;
      bottom: -140px;
      right: -140px;
      width: 380px;
      height: 380px;
      background: radial-gradient(closest-side, rgba(114,190,255,0.14), rgba(114,190,255,0));
      filter: blur(6px);
    }
    
    .results-section {
      background: linear-gradient(180deg, #ffffff 0%, #f6f9ff 100%);
      position: relative;
    }
    
    .results-bg-pattern {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="waves" width="40" height="40" patternUnits="userSpaceOnUse"><path d="M0,20 Q10,10 20,20 T40,20" fill="none" stroke="rgba(28,62,138,0.06)" stroke-width="1"/></pattern></defs><rect width="100" height="100" fill="url(%23waves)"/></svg>');
      opacity: 0.5;
    }
    
    .intelligence-section {
      background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
      position: relative;
    }
    
    .section-header {
      text-align: center;
      margin-bottom: 3rem;
    }
    
    .section-badge {
      display: inline-block;
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      color: white;
      padding: 8px 20px;
      border-radius: 25px;
      font-size: 0.9rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 1rem;
      box-shadow: 0 4px 12px rgba(28,62,138,0.3);
    }
    
    /* Image Container */
    .image-container {
      position: relative;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 12px 32px rgba(0,0,0,0.15);
      max-width: 400px;
      margin: 0 auto;
    }
    
    .image-container img {
      max-height: 250px;
      width: 100%;
      object-fit: cover;
    }
    
    .image-overlay {
      position: absolute;
      inset: 0;
      background: linear-gradient(135deg, rgba(28,62,138,0.1), rgba(44,90,160,0.1));
      opacity: 0;
      transition: opacity .3s ease;
    }
    
    .image-container:hover .image-overlay {
      opacity: 1;
    }
    
    /* Final CTA Section */
    .final-cta-section {
      background: linear-gradient(135deg, #1c3e8a 0%, #2c5aa0 50%, #3b82f6 100%);
      position: relative;
      overflow: hidden;
      padding: 80px 0;
    }
    
    .final-cta-wrapper {
      position: relative;
      background: rgba(255, 255, 255, 0.95);
      border-radius: 24px;
      padding: 3rem;
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      backdrop-filter: blur(10px);
    }
    
    .final-cta-content {
      position: relative;
      z-index: 2;
    }
    
    .final-cta-badge {
      display: inline-block;
      background: linear-gradient(135deg, #f59e0b, #fbbf24);
      color: white;
      padding: 0.5rem 1rem;
      border-radius: 20px;
      font-size: 0.875rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      margin-bottom: 1rem;
    }
    
    .final-cta-title {
      font-size: 2.5rem;
      color: #1f2937;
      margin-bottom: 1rem;
      line-height: 1.2;
    }
    
    .final-cta-description {
      font-size: 1.125rem;
      color: #6b7280;
      margin-bottom: 2rem;
      line-height: 1.6;
    }
    
    .final-cta-actions {
      display: flex;
      gap: 1rem;
      flex-wrap: wrap;
    }
    
    .final-cta-primary-btn {
      background: linear-gradient(135deg, #1c3e8a, #2c5aa0);
      border: none;
      color: white;
      padding: 1rem 2rem;
      border-radius: 12px;
      font-size: 1rem;
      font-weight: 600;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(28, 62, 138, 0.3);
    }
    
    .final-cta-primary-btn:hover {
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(28, 62, 138, 0.4);
      color: white;
      text-decoration: none;
    }
    
    .final-cta-secondary-btn {
      background: rgba(255, 255, 255, 0.9);
      border: 2px solid #1c3e8a;
      color: #1c3e8a;
      padding: 1rem 2rem;
      border-radius: 12px;
      font-size: 1rem;
      font-weight: 600;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
      transition: all 0.3s ease;
      backdrop-filter: blur(10px);
    }
    
    .final-cta-secondary-btn:hover {
      background: #1c3e8a;
      color: white;
      transform: translateY(-2px);
      box-shadow: 0 8px 20px rgba(28, 62, 138, 0.3);
      text-decoration: none;
    }
    
    .final-cta-visual {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
    }
    
    .final-cta-icon-container {
      position: relative;
      width: 200px;
      height: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, rgba(28, 62, 138, 0.1), rgba(59, 130, 246, 0.1));
      border-radius: 50%;
      backdrop-filter: blur(10px);
      animation: float 3s ease-in-out infinite;
    }
    
    .final-cta-icon {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      object-fit: cover;
    }
    
    .final-icon-glow {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 240px;
      height: 240px;
      background: radial-gradient(circle, rgba(28, 62, 138, 0.2) 0%, transparent 70%);
      border-radius: 50%;
      animation: pulse 2s infinite;
    }
    
    @keyframes pulse {
      0%, 100% {
        opacity: 0.5;
        transform: translate(-50%, -50%) scale(1);
      }
      50% {
        opacity: 0.8;
        transform: translate(-50%, -50%) scale(1.1);
      }
    }
    
    @keyframes float {
      0%, 100% {
        transform: translateY(0px);
      }
      50% {
        transform: translateY(-10px);
      }
    }
    
    /* Responsive Design */
    @media (max-width: 768px) {
      .col-lg-7, .col-lg-5, .col-lg-6, .col-lg-4, .col-lg-3, .col-lg-8, .col-lg-12, .col-md-6, .col-md-4, .col-md-3, .col-sm-6, .col-sm-12 {
        flex: 0 0 100%;
        max-width: 100%;
      }
      
      .analytics-cta {
        flex-direction: column;
        gap: 8px;
      }
      
      .analytics-cta-btn {
        width: 100%;
        justify-content: center;
      }
      
      .final-cta-wrapper {
        padding: 2rem 1.5rem;
      }
      
      .final-cta-title {
        font-size: 2rem;
      }
      
      .final-cta-actions {
        flex-direction: column;
      }
      
      .final-cta-primary-btn,
      .final-cta-secondary-btn {
        width: 100%;
        justify-content: center;
      }
      
      .final-cta-icon-container {
        width: 150px;
        height: 150px;
      }
      
      .final-cta-icon {
        width: 80px;
        height: 80px;
      }
      
      /* Benefits Section Responsive */
      .benefits-intro-text {
        font-size: 1.1rem;
      }

      .benefits-image-container {
        margin-bottom: 30px;
      }

      .benefits-content-title {
        font-size: 1.6rem;
      }

      .benefits-content-description {
        font-size: 1rem;
      }

      .benefits-features-list {
        grid-template-columns: 1fr;
        gap: 12px;
      }

      .benefits-stats-panel {
        grid-template-columns: 1fr;
        padding: 30px 20px;
        gap: 20px;
      }

      .benefits-stat-item {
        padding: 20px;
      }

      .stat-icon-wrapper {
        width: 50px;
        height: 50px;
        margin-right: 15px;
      }

      .stat-content-wrapper .stat-number {
        font-size: 1.8rem;
      }

      .stat-content-wrapper .stat-label {
        font-size: 0.85rem;
      }

      .convergence-flow {
        flex-direction: column;
        padding: 30px 20px;
        gap: 20px;
      }

      .convergence-item,
      .convergence-result {
        width: 100%;
        min-width: auto;
      }

      .convergence-connector {
        transform: rotate(90deg);
      }

      .benefits-section-title {
        font-size: 1.5rem;
      }
      
      /* Convergence Value Responsive */
      .convergence-value-subtitle {
        font-size: 1rem;
        padding: 0 15px;
      }
      
      .convergence-value-card {
        padding: 25px 20px;
      }
      
      .convergence-value-icon {
        width: 65px;
        height: 65px;
        margin-bottom: 15px;
      }
      
      .convergence-value-icon i {
        width: 28px;
        height: 28px;
      }
      
      .convergence-value-title {
        font-size: 1.2rem;
      }
      
      .convergence-value-description {
        font-size: 0.95rem;
      }
      
      .example-item {
        font-size: 0.85rem;
      }
      
      .impact-metric {
        font-size: 1.6rem;
      }
    }
  `]
})
export class AnalyticsComponent implements OnInit, AfterViewInit {

  analyticsTypes = [
    {
      icon: 'trending-up',
      title: 'Predictive Analytics',
      subtitle: 'See Beyond the Present',
      description: 'Harness AI, machine learning, and advanced statistics to anticipate future outcomes:',
      features: [
        'Demand Forecasting: Plan ahead for customer needs and market shifts.',
        'Risk Anticipation: Identify operational, financial, and cybersecurity risks proactively.',
        'Trend Analysis: Spot emerging patterns to seize opportunities and mitigate threats.'
      ],
      color: 'blue'
    },
    {
      icon: 'target',
      title: 'Prescriptive Analytics',
      subtitle: 'Recommend the Right Action',
      description: 'Turn predictions into actionable strategies:',
      features: [
        'Scenario Planning: Simulate multiple outcomes to guide decisions.',
        'Actionable Recommendations: Optimize processes, reduce costs, and improve efficiency.',
        'Performance Optimization: Drive faster, smarter, data-backed strategies.'
      ],
      color: 'blue'
    },
    {
      icon: 'shield-check',
      title: 'Preventive Analytics',
      subtitle: 'Stop Issues Before They Arise',
      description: 'Stay ahead of disruptions with proactive insights:',
      features: [
        'Risk Mitigation: Detect bottlenecks and compliance gaps early.',
        'Maintenance Forecasting: Prevent equipment failures and downtime.',
        'Security Safeguards: Identify anomalies and cyber threats in real time.'
      ],
      color: 'red'
    }
  ];

  benefits = [
    {
      icon: 'zap',
      title: 'Real-time Intelligence',
      description: 'Real-time intelligence for faster, confident decisions'
    },
    {
      icon: 'shield',
      title: 'Proactive Risk Mitigation',
      description: 'Proactive risk mitigation across functions'
    },
    {
      icon: 'cog',
      title: 'Optimized Operations',
      description: 'Optimized operations through AI and automation'
    },
    {
      icon: 'trending-up',
      title: 'Strategic Foresight',
      description: 'Strategic foresight to adapt to market changes'
    }
  ];

  convergenceBenefits = [
    {
      icon: 'zap',
      category: 'Speed',
      title: 'Real-time Intelligence',
      description: 'Combined analytics provide instant insights across predictive, prescriptive, and preventive dimensions, enabling rapid decision-making.',
      examples: [
        'Cross-functional data correlation',
        'Unified dashboard views',
        'Instant anomaly detection'
      ],
      impact: '3x Faster'
    },
    {
      icon: 'shield',
      category: 'Protection',
      title: 'Proactive Risk Mitigation',
      description: 'Predictive warnings trigger prescriptive actions that prevent issues before they impact operations, creating a comprehensive safety net.',
      examples: [
        'Early warning systems',
        'Automated interventions',
        'Multi-layer security'
      ],
      impact: '95% Reduction'
    },
    {
      icon: 'cog',
      category: 'Efficiency',
      title: 'Optimized Operations',
      description: 'Predictive insights feed prescriptive recommendations that optimize resource allocation while preventive controls ensure smooth execution.',
      examples: [
        'Resource optimization',
        'Process automation',
        'Cost reduction'
      ],
      impact: '40% Improvement'
    },
    {
      icon: 'trending-up',
      category: 'Growth',
      title: 'Strategic Foresight',
      description: 'The convergence enables organizations to see future trends, plan optimal strategies, and prevent disruptions—creating sustainable competitive advantage.',
      examples: [
        'Market trend analysis',
        'Strategic planning',
        'Competitive advantage'
      ],
      impact: '2x Growth'
    }
  ];

  results = [
    {
      metric: '20–30%',
      title: 'Operational Efficiency Boost',
      description: 'improvement in operational efficiency through proactive risk prevention'
    },
    {
      metric: 'Faster',
      title: 'AI-Driven Decision Making',
      description: 'decision-making with AI-driven insights'
    },
    {
      metric: 'Stronger',
      title: 'Enhanced Compliance',
      description: 'compliance and governance with real-time monitoring'
    },
    {
      metric: 'Sustainable',
      title: 'Data-Driven Growth',
      description: 'growth through data-driven innovation and strategic foresight'
    }
  ];

  constructor() { 
    console.log('AnalyticsComponent constructor called');
  }

  ngOnInit(): void {
    console.log('AnalyticsComponent ngOnInit called');
  }

  ngAfterViewInit(): void {
    // Initialize Lucide icons
    if (typeof lucide !== 'undefined') {
      lucide.createIcons();
    }
  }

}
